import { resourceKeys } from '@aimmo/ui';
import { api, assertOk } from '../lib/api.js';
import { makeLookup } from '../lib/lookup.js';

/**
 * The pickers the activity dialog needs and nothing else had (U5): a mandate, a
 * demand, and the appointment type.
 *
 * Same shape as every other lookup here — a typed search against the API, never
 * a loaded list.
 */
export const { search: searchMandates, resolve: resolveMandate } = makeLookup({
  key: resourceKeys.all('mandates'),
  search: async (query, signal) =>
    assertOk(
      await api.mandates.list({
        query: { page: 1, pageSize: 20, order: 'desc', ...(query ? { q: query } : {}) },
        fetchOptions: { signal },
      }),
    ).body.items,
  get: async (id, signal) =>
    assertOk(await api.mandates.get({ params: { id }, fetchOptions: { signal } })).body,
  toOption: (mandate) => ({
    value: mandate.id,
    label: mandate.title ?? `${mandate.propertyLabel} · ${mandate.ownerName}`,
  }),
});

export const { search: searchDemands, resolve: resolveDemand } = makeLookup({
  key: resourceKeys.all('demands'),
  search: async (query, signal) =>
    assertOk(
      await api.demands.list({
        query: { page: 1, pageSize: 20, order: 'desc', ...(query ? { q: query } : {}) },
        fetchOptions: { signal },
      }),
    ).body.items,
  get: async (id, signal) =>
    assertOk(await api.demands.get({ params: { id }, fetchOptions: { signal } })).body,
  toOption: (demand) => ({ value: demand.id, label: `Richiesta di ${demand.contactName}` }),
});

export const { search: searchAppointmentTypes, resolve: resolveAppointmentType } = makeLookup({
  key: resourceKeys.all('appointment-types'),
  search: async (query, signal) =>
    assertOk(
      await api.appointmentTypes.list({
        query: { page: 1, pageSize: 50, order: 'asc', ...(query ? { q: query } : {}) },
        fetchOptions: { signal },
      }),
    ).body.items,
  get: async (id, signal) =>
    assertOk(await api.appointmentTypes.get({ params: { id }, fetchOptions: { signal } })).body,
  toOption: (type) => ({ value: type.id, label: type.label }),
});
